"use client";

import { FC, PropsWithChildren } from "react";
import Menu from "components/menu/Menu";
import { useSiteConfig } from "@finbackoffice/site-core";
import { ISiteConfigLayouts } from "@finbackoffice/fe-core";
import SubHeader from "components/sub-header/SubHeader";
import Header from "components/header/Header";
import styles from "./mobile-layout.module.sass";

const MobileLayout: FC<PropsWithChildren> = ({ children }) => {
    const siteLayoutsConfig = useSiteConfig<ISiteConfigLayouts>("layouts");

    return (
        <section className={styles.container}>
            <Header layout="default" />
            {siteLayoutsConfig.subHeader.enable && <SubHeader />}
            {children}
            <Menu />
        </section>
    );
};

export default MobileLayout;
